/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
// libraries

import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { Key, useEffect, useState } from 'react';

// Dynamic Imports para otimizar client-side
const WelcomePieces = dynamic(() => import('../components/pieces/welcome/WelcomePieces'), { ssr: true });
const WelcomePieces2 = dynamic(() => import('../components/pieces/welcome2/WelcomePieces2'), { ssr: true });
const WelcomePieces3 = dynamic(() => import('../components/pieces/welcome3/WelcomePieces'), { ssr: true });
const Topo = dynamic(() => import('../components/pieces/topo/Topo'), { ssr: true });
const Topo2 = dynamic(() => import('../components/pieces/topo2/Topo'), { ssr: true });
const PopUpComponent = dynamic(() => import('../components/popUp/PopUpComponent'), { ssr: false });
const OwnersPieces = dynamic(() => import('../components/pieces/owners/OwnersPieces'), { ssr: false });
const BusinessPieces = dynamic(() => import('../components/pieces/business/BusinessPieces'), { ssr: true });
const ApartamentCard = dynamic(() => import('../components/carousel/apartment/ApartamentCard'), { ssr: false });
const ApartamentCard1 = dynamic(() => import('../components/carousel/apartment/ApartamentCard1'), { ssr: false });
const WhatsAppComponent = dynamic(() => import('../components/fixed/whatsapp/WhatsappComponent'), { ssr: false });
const ChannelChatWidget = dynamic(() => import('../components/fixed/channelChat/ChannelChatWidget'), { ssr: false });
const FavoritosComponent = dynamic(() => import('../components/fixed/favoritos/FavoritosComponent'), { ssr: false });
const Popup = dynamic(() => import('../components/pieces/popup/popup'), { ssr: false });
const Simulador = dynamic(() => import('../components/pieces/simulador/simulador'), { ssr: false });
const DepoimentoCard = dynamic(() => import('../components/carousel/depoimentos/DepoimentosCard'), { ssr: false });
const DepoimentoCard2 = dynamic(() => import('../components/carousel/depoimentos/DepoimentosCard2'), { ssr: false });
const ManagerCard = dynamic(() => import('../components/carousel/manager/ManagerCard'), { ssr: false });
const NoticePieces = dynamic(() => import('../components/pieces/notice/NoticePieces'), { ssr: false });
const NoveltyPieces = dynamic(() => import('../components/pieces/novelty/NoveltyPieces'), { ssr: false });
const Novidades = dynamic(() => import('../components/pieces/novidades/Novidades'), { ssr: false });
const SelectionCarousel = dynamic(() => import('../components/carousel/selection/SelectionCarousel'), { ssr: false });
const SkeletonApartamentCard= dynamic(() => import('../components/cards/apartament/SkeletonApartamentCard'), { ssr: false });
const SocialNetworks= dynamic(() => import('../components/pieces/socialNetworks/SocialNetworks'), { ssr: false });
const BlogCarousel= dynamic(() => import('../components/carousel/blog/BlogCarousel'), { ssr: false });
const FeaturedHomeCarousel = dynamic(() => import('../components/carousel/featured_home/FeaturedHomeCarousel'), { ssr: false });

// About - ja estava como dynamic (ok!)
const AboutPieces = dynamic(() => import('../components/pieces/about/AboutPieces'), { ssr: true });
const AboutPieces1 = dynamic(() => import('../components/pieces/about1/AboutPieces1'), { ssr: true });
const AboutPieces2 = dynamic(() => import('../components/pieces/about1/AboutPieces2'), { ssr: true });
const SelectionCarouselImages = dynamic(() => import('../components/carousel/selection_destaque/SelectionCarousel'), { ssr: false });

// Servicos
import { useAuth } from '../components/context/Info';
import LazyRender from '../components/utils/LazyRender';
import { getHomeServerSideProps } from '../lib/server/site-props';
import styles from '../styles/Home.module.css';
import { formatSelects, formatSelectsTransacao } from '../utils/FunctionsGlobals';
import { getHomeScopedStorageKey } from '../utils/homeCache';
import { runWhenIdle } from '../utils/idle';
import SiteHead from '../utils/siteHead';
import { getWithTTL, setWithTTL } from '../utils/storage';
import { isLocalOrTestHost, normalizeHost } from '../utils/url';

// MAIN COMPONENT

export const getServerSideProps = getHomeServerSideProps;

const MotionDiv = ({ children }: any) => <div>{children}</div>;

let selectorsServicePromise: Promise<typeof import('../services/selectors')> | null = null;
const loadSelectorsService = () => {
    if (!selectorsServicePromise) {
        selectorsServicePromise = import('../services/selectors');
    }
    return selectorsServicePromise;
};

let propertiesServicePromise: Promise<typeof import('../services/properties')> | null = null;
const loadPropertiesService = () => {
    if (!propertiesServicePromise) {
        propertiesServicePromise = import('../services/properties');
    }
    return propertiesServicePromise;
};

const CARROSSEIS_CACHE_TTL_MS = 15 * 60 * 1000;

const parseCachedPayload = <T,>(value: unknown): T | null => {
    if (value == null) return null;
    if (typeof value === 'string') {
        try {
            return JSON.parse(value) as T;
        } catch {
            return null;
        }
    }
    return value as T;
};

const resolveHomeCarouselQueryHost = (originHost: unknown, siteDomainHost: unknown): string => {
    const normalizedOriginHost = normalizeHost(String(originHost || ''));
    const normalizedSiteDomainHost = normalizeHost(String(siteDomainHost || ''));

    if (normalizedOriginHost && isLocalOrTestHost(normalizedOriginHost) && normalizedSiteDomainHost) {
        return normalizedSiteDomainHost;
    }

    return normalizedOriginHost || normalizedSiteDomainHost;
};

const Home = () => {
    const router = useRouter();
    const { simulador } = router.query;
    const {
        allDataHome,
        favorito,
        setFavorito,
        allViewProperties,
        isMobile1,
        init_props,
        politic,
        setAllCompany,
        allCompany,
        listCaracteristicas,
        allCarrosseis,
        all_cards_home,
        setAllCarrosseis
    } = useAuth();

    // useState
    const valores = {precos_venda: [allDataHome?.precos_venda[0] || null], precos_locacao: [allDataHome?.precos_locacao[0] || null]};
    const site = allDataHome?.site;
    const [open, setOpen] = useState(site?.id == 1679 ? true : false);
    const [whatsAppActivated, setWhatsAppActivated] = useState(site?.id == 1679 ? true : false);
    const allOwners = allDataHome?.banner_empresa;
    const allCards = init_props?.allCards || all_cards_home || [];
    const codsite2 = init_props?.codsite;
    const { codsite } = router.query;
    const allManagers = allDataHome?.parceiros?.filter(
        (v: any) => v.url_foto?.length
    ) || [];
    const featuredCarrosseis = init_props?.carrosseis_destaque || [];
    const allDepoimentos = allDataHome?.depoimentos?.filter(
        (v: any) => v.depoimento?.length
    ) || [];
    const dataHome = allDataHome;
    const origin = init_props?.prodOrigin;
    const homeStorageHost = normalizeHost(
        origin || init_props?.origemInit || site?.site || (typeof window !== 'undefined' ? window.location.host : '')
    );
    const homeStorageCodsite = codsite2 || site?.id || 0;
    const homeCondominiosStorageKey = getHomeScopedStorageKey(
        'condominios',
        homeStorageHost,
        homeStorageCodsite
    );
    const homeCarouselQueryHost = resolveHomeCarouselQueryHost(init_props?.prodOrigin, site?.site);
    const bannerHome = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "home");
    const bannerPopup = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "popup");
    const bannerFundo = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "fundo");
    const redes_sociais = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "redes_sociais");
    const bannerTopo = allDataHome?.allBanners.filter((item: { ativo: Boolean; }) => item.ativo === true);
    const bannerPersona = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "persona_home");
    const persona_redes = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "persona_redes");
    const fundo_blog = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "blog");
    const urlBannerHome = bannerHome ? bannerHome.length > 0 ? bannerHome : null : null;
    const homeBannerOverride2523 = "https://imob.sobressai.com.br/Banner/2523/12362.jpg";
    const resolvedUrlBannerHome =
        Number(site?.id) === 2523 && urlBannerHome?.length
            ? urlBannerHome.map((item: any, index: number) => (
                index === 0 ? { ...item, url: homeBannerOverride2523 } : item
            ))
            : urlBannerHome;
    const urlBannerPopup = bannerPopup ? bannerPopup.length > 0 ? bannerPopup : null : null;
    const urlBannerFundo = bannerFundo ? bannerFundo.length > 0 ? bannerFundo[0] : null : null;
    const urlBlogFundo = fundo_blog ? fundo_blog.length > 0 ? fundo_blog[0] : "" : "";
    const urlBannerTopo = bannerTopo ? bannerTopo.length > 0 ? bannerTopo[0] : null : null;
    const urlBannerPersona = bannerPersona ? bannerPersona.length > 0 ? bannerPersona[0] : null : null;
    const urlBannePersonaRedes = persona_redes ? persona_redes.length > 0 ? persona_redes[0] : null : null;
    const urlBannerRedesSociais = redes_sociais ? redes_sociais.length > 0 ? redes_sociais[0] : null : null;
    const [companyInputActual, setCompanyInputActual] = useState('');
    const [fullScreen, setFullScreen] = useState(0);
    const [buscaAvancada, setBuscaAvancada] = useState(false);

    const [fullScreenPopup, setFullScreenPopup] = useState(0);
    const [activeDrawer, setActiveDrawer] = useState<any>(null);
    const allTypes = allDataHome?.tipos ? formatSelects(allDataHome?.tipos) : [];
    const allCities = allDataHome?.cidades ? formatSelects(allDataHome?.cidades,allDataHome?.site?.cidade_priorizada) : [];
    const allTransacao = allDataHome?.site?.transacoes ? formatSelectsTransacao(allDataHome?.site?.transacoes) : []
    const total_carrosseis = allDataHome?.carrosseis?.length || 0;
    const [carregando_carrosseis, setCarregando_carrosseis] = useState<any>(allCarrosseis?.length == 0 && total_carrosseis > 0 ? false : true);

    useEffect(() => {
        const cleanup = runWhenIdle(() => {
            GetInfoSite();
        }, 1200);
        if(simulador == "1"){
            setFullScreen(1);
        }
        return cleanup;
    }, [simulador]);

    useEffect(() => {
        const cleanup = runWhenIdle(() => {
            if(total_carrosseis > 0 && allCarrosseis?.length == 0){
                GetCachesCarr();
            } else {
                setCarregando_carrosseis(true);
            }
        }, 1200);
        return cleanup;
    }, [allCarrosseis?.length, total_carrosseis, site?.id]);

    useEffect(() => {
        if (site?.id == 1679) {
            setWhatsAppActivated(true);
            setOpen(true);
        }
    }, [site?.id]);

    useEffect(() => {
        if (allCompany?.length == 0 && site?.exibir_empreendimento) {
            const timeOutId = setTimeout(() => {
                const getCondo: any = JSON.parse(localStorage.getItem(homeCondominiosStorageKey) || '[]');
                if (Array.isArray(getCondo) && getCondo.length > 0) {
                    setAllCompany(getCondo);
                    return;
                }
                if (getCondo?.empreendimentos?.length > 0) {
                    setAllCompany(formatSelects(getCondo.empreendimentos));
                    return;
                }
                if (companyInputActual || site?.id == 2427 || site?.id == 2567 || site?.id == 2274) {
                    GetAllCompany();
                }
            }, 1000);
            return () => clearTimeout(timeOutId);
        }
    }, [companyInputActual, homeCondominiosStorageKey, site?.exibir_empreendimento, site?.id, allCompany?.length]);

    const GetInfoSite = async () => {
        GetBannerNovidades();
        window.localStorage.removeItem(homeCondominiosStorageKey);
    };

    const GetAllCompany = async () => {
        if(allCompany?.length == 0 && site?.exibir_empreendimento ) {
            const { getCompany } = await loadSelectorsService();
            const infoCompany = await getCompany('',origin, codsite2);
            setAllCompany(formatSelects(infoCompany?.empreendimentos));
            localStorage.setItem(homeCondominiosStorageKey, JSON.stringify(infoCompany));
        }
    };

    const GetCachesCarr = async () => {
        const length = allDataHome?.carrosseis?.length || 0;
        if (length <= 0) {
            setCarregando_carrosseis(true);
            return;
        }

        const cacheKey = getHomeScopedStorageKey(
            'all_carrosseis',
            homeStorageHost,
            homeStorageCodsite,
            length
        );
        const cachedList = parseCachedPayload<any[]>(getWithTTL<any>(cacheKey));

        if (Array.isArray(cachedList) && cachedList.length > 0) {
            setAllCarrosseis(cachedList);
            setCarregando_carrosseis(true);
            return;
        }

        let all_carrosseis: any[] = [];

        if (allDataHome) {
            const {
                imoveis_novidades,
                properties_carrossel,
                propertiesTop10
            } = await loadPropertiesService();

            for (const element of allDataHome.carrosseis) {
                if (element.personalizado) {
                    const itemCacheKey = getHomeScopedStorageKey(
                        'carrossel',
                        homeStorageHost,
                        homeStorageCodsite,
                        element.id || 0
                    );
                    const cachedItems = parseCachedPayload<any[]>(getWithTTL<any>(itemCacheKey));

                    if (Array.isArray(cachedItems) && cachedItems.length > 2) {
                        all_carrosseis.push([element, cachedItems]);
                        continue;
                    }

                    const resultado = await properties_carrossel(
                        element,
                        '',
                        homeCarouselQueryHost || init_props?.prodOrigin,
                        codsite2
                    );

                    const items = resultado?.imoveis?.imoveis;
                    if (Array.isArray(items) && items.length > 2) {
                        all_carrosseis.push([element, items]);
                        setWithTTL(itemCacheKey, items, CARROSSEIS_CACHE_TTL_MS);
                    }
                    continue;
                }

                if (element.novidades_semana) {
                    const itemCacheKey = getHomeScopedStorageKey(
                        'imoveis_novidade',
                        homeStorageHost,
                        homeStorageCodsite
                    );
                    const cachedItems = parseCachedPayload<any[]>(getWithTTL<any>(itemCacheKey));

                    if (Array.isArray(cachedItems) && cachedItems.length > 2) {
                        all_carrosseis.push([element, cachedItems]);
                        continue;
                    }

                    const resultado = await imoveis_novidades(
                        '',
                        homeCarouselQueryHost || init_props?.prodOrigin,
                        codsite2,
                        ''
                    );
                    const items = resultado?.imoveis_novidades;

                    if (Array.isArray(items) && items.length > 2) {
                        all_carrosseis.push([element, items]);
                        setWithTTL(itemCacheKey, items, CARROSSEIS_CACHE_TTL_MS);
                    }
                    continue;
                }

                if (element.top_10) {
                    const itemCacheKey = getHomeScopedStorageKey(
                        'properties_top10',
                        homeStorageHost,
                        homeStorageCodsite,
                        element?.id || 0
                    );
                    const cachedItems = parseCachedPayload<any[]>(getWithTTL<any>(itemCacheKey));

                    if (Array.isArray(cachedItems) && cachedItems.length > 2) {
                        all_carrosseis.push([element, cachedItems]);
                        continue;
                    }

                    const resultado = await propertiesTop10(
                        '',
                        homeCarouselQueryHost || init_props?.prodOrigin,
                        codsite2,
                        ''
                    );
                    const items = resultado?.imoveis_destaque;

                    if (Array.isArray(items) && items.length > 2) {
                        all_carrosseis.push([element, items]);
                        setWithTTL(itemCacheKey, items, CARROSSEIS_CACHE_TTL_MS);
                    }
                }
            }
        }

        if (Array.isArray(all_carrosseis) && all_carrosseis.length > 0) {
            setAllCarrosseis(all_carrosseis);
            setWithTTL(cacheKey, all_carrosseis, CARROSSEIS_CACHE_TTL_MS);
        }

        setCarregando_carrosseis(true);
    };

    const GetBannerNovidades = async () => {
        const variavelSalva = sessionStorage.getItem('bannerPopup');
        if (variavelSalva != "true" && urlBannerPopup) {
            sessionStorage.setItem('bannerPopup', 'true');
            setFullScreenPopup(1);
        } else {
            setFullScreenPopup(0);
        }
    };

    const handleOpenWhatsApp = () => {
        setWhatsAppActivated(true);
        setOpen(true);
    };

    const renderRodape = () => {
        const hidePopularHome = Number(site?.id) === 2551;

        switch (site?.rodape) {
            case 1:
                return (
                    <MotionDiv
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito} hidePopular={hidePopularHome}/>
                    </MotionDiv>
                );
            case 2:
                return (
                    <AboutPieces allRodape={allDataHome?.rodape} site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} hidePopular={hidePopularHome}/>
                );
            case 3:
                return (
                    <AboutPieces2 site={site} allRodape={allDataHome?.rodape} hidePopular={hidePopularHome}/>
                );
            default:
            return (
                <MotionDiv
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito} hidePopular={hidePopularHome}/>
                </MotionDiv>
            );
        }
    }

    const renderCarrosselCard = (carrossel: any, idx: Key | null | undefined) => {
        switch (site?.modelo_card) {
            case 1:
            return (
                <ApartamentCard
                    key={idx}
                    slides={carrossel[1]}
                    url={carrossel[0]?.url_red ? carrossel[0]?.url_red : site?.transacoes ? `/imoveis/${site.transacoes[0].toLowerCase()}/-/-/-/-?ordem=desc-inclusao` : ""}
                    title={carrossel[0]?.titulo ? carrossel[0]?.titulo : `CARROSSEL ${allCarrosseis?.length}`}
                    site={site}
                    favorito={favorito || []}
                    setFavorito={setFavorito}
                    codsite={codsite}
                    is_mobile={isMobile1}
                    allViewProperties={allViewProperties}
                />
            );
            case 2:
                return (
                    <ApartamentCard1
                        key={idx}
                        slides={carrossel[1]}
                        url={carrossel[0]?.url_red ? carrossel[0]?.url_red : site?.transacoes ? `/imoveis/${site.transacoes[0].toLowerCase()}/-/-/-/-?ordem=desc-inclusao` : ""}
                        title={carrossel[0]?.titulo ? carrossel[0]?.titulo : `CARROSSEL ${allCarrosseis?.length}`}
                        site={site}
                        favorito={favorito || []}
                        setFavorito={setFavorito}
                        codsite={codsite}
                        is_mobile={isMobile1}
                        cores={carrossel[0]}
                        allViewProperties={allViewProperties}
                    />
                );
            case 3:
                return (
                    <ApartamentCard1
                        key={idx}
                        slides={carrossel[1]}
                        url={carrossel[0]?.url_red ? carrossel[0]?.url_red : site?.transacoes ? `/imoveis/${site.transacoes[0].toLowerCase()}/-/-/-/-?ordem=desc-inclusao` : ""}
                        title={carrossel[0]?.titulo ? carrossel[0]?.titulo : `CARROSSEL ${allCarrosseis?.length}`}
                        site={site}
                        favorito={favorito || []}
                        setFavorito={setFavorito}
                        codsite={codsite}
                        is_mobile={isMobile1}
                        cores={carrossel[0]}
                        allViewProperties={allViewProperties}
                    />
                );
            default:
                return (
                    <ApartamentCard
                    key={idx}
                    slides={carrossel[1]}
                    url={carrossel[0]?.url_red ? carrossel[0]?.url_red : site?.transacoes ? `/imoveis/${site.transacoes[0].toLowerCase()}/-/-/-/-?ordem=desc-inclusao` : ""}
                    title={carrossel[0]?.titulo ? carrossel[0]?.titulo : `CARROSSEL ${allCarrosseis?.length}`}
                    site={site}
                    favorito={favorito || []}
                    setFavorito={setFavorito}
                    codsite={codsite}
                    is_mobile={isMobile1}
                    allViewProperties={allViewProperties}
                    />
                );
        }
    };

    const renderWelcomePieces = () => {
        switch (site?.modelo_busca) {
            case 1:
            return (
                <WelcomePieces
                    allCities={allCities}
                    allTypes={allTypes}
                    allTransacao={allTransacao}
                    allCompany={allCompany}
                    site={site}
                    urlBanner={urlBannerTopo ? urlBannerTopo?.url : ""}
                    companyInputActual={companyInputActual}
                    setCompanyInputActual={setCompanyInputActual}
                    setActiveDrawer={setActiveDrawer}
                    activeDrawer={activeDrawer}
                    favorito={favorito}
                    origin={origin}
                    codsite={codsite2}
                    valores={valores}
                    codsite2={codsite}
                    isMobile1={isMobile1}
                    props={allDataHome}
                    allCards={allCards}
                />
            );
            case 2:
                return (
                    <WelcomePieces2
                        allCities={allCities}
                        allTypes={allTypes}
                        allTransacao={allTransacao}
                        allCompany={allCompany}
                        site={site}
                        buscaAvancada={buscaAvancada}
                        setBuscaAvancada={setBuscaAvancada}
                        personaSrc={urlBannerPersona ? urlBannerPersona?.url : ""}
                        urlBanner={urlBannerTopo ? urlBannerTopo?.url : ""}
                        companyInputActual={companyInputActual}
                        setCompanyInputActual={setCompanyInputActual}
                        setActiveDrawer={setActiveDrawer}
                        activeDrawer={activeDrawer}
                        favorito={favorito}
                        origin={origin}
                        codsite={codsite2}
                        valores={valores}
                        codsite2={codsite}
                        isMobile1={isMobile1}
                        props={allDataHome}
                    />
                );
            case 3:
                return (
                    <WelcomePieces3
                        allCities={allCities}
                        allTypes={allTypes}
                        allTransacao={allTransacao}
                        allCompany={allCompany}
                        site={site}
                        companyInputActual={companyInputActual}
                        setCompanyInputActual={setCompanyInputActual}
                        setActiveDrawer={setActiveDrawer}
                        activeDrawer={activeDrawer}
                        favorito={favorito}
                        origin={origin}
                        codsite={codsite2}
                        valores={valores}
                        codsite2={codsite}
                        isMobile1={isMobile1}
                        props={allDataHome}
                        allCards={allCards}
                    />
                );
            default:
                return (
                    <WelcomePieces
                        allCities={allCities}
                        allTypes={allTypes}
                        allTransacao={allTransacao}
                        allCompany={allCompany}
                        site={site}
                        urlBanner={urlBannerTopo ? urlBannerTopo?.url : ""}
                        companyInputActual={companyInputActual}
                        setCompanyInputActual={setCompanyInputActual}
                        setActiveDrawer={setActiveDrawer}
                        activeDrawer={activeDrawer}
                        favorito={favorito}
                        origin={origin}
                        codsite={codsite2}
                        valores={valores}
                        codsite2={codsite}
                        isMobile1={isMobile1}
                        props={allDataHome}
                        allCards={allCards}
                    />
                );
        }
    };

    const renderFeaturedHomeCarousel = () => {
        if (!featuredCarrosseis?.length) return null;

        return (
            <FeaturedHomeCarousel
                items={featuredCarrosseis}
                codsite={codsite2}
                origin={origin}
                site={site}
            />
        );
    };

    return (
        <div className={styles.container} style={{backgroundColor: site?.cor5}}>
            {allDataHome ? <SiteHead allDataHome={allDataHome} pagina={"home"} canonicalHost={init_props?.prodOrigin} /> : null}
            {Number(site?.id) === 2439 && !whatsAppActivated ? <ChannelChatWidget /> : null}
            {site && site?.id != 2049 && !whatsAppActivated && (
                <button
                    type="button"
                    className={site?.id == 1893 ? styles.whatsFabAlt : styles.whatsFab}
                    aria-label="Abrir atendimento no WhatsApp"
                    onClick={handleOpenWhatsApp}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1219.547 1225.016"
                        className={site?.id == 1874 || site?.id == 2355 ? styles.svg_whats1 : styles.svg_whats}
                    >
                        <path fill="#E0E0E0" d="M1041.858 178.02C927.206 63.289 774.753.07 612.325 0 277.617 0 5.232 272.298 5.098 606.991c-.039 106.986 27.915 211.42 81.048 303.476L0 1225.016l321.898-84.406c88.689 48.368 188.547 73.855 290.166 73.896h.258.003c334.654 0 607.08-272.346 607.222-607.023.056-162.208-63.052-314.724-177.689-429.463zm-429.533 933.963h-.197c-90.578-.048-179.402-24.366-256.878-70.339l-18.438-10.93-191.021 50.083 51-186.176-12.013-19.087c-50.525-80.336-77.198-173.175-77.16-268.504.111-278.186 226.507-504.503 504.898-504.503 134.812.056 261.519 52.604 356.814 147.965 95.289 95.36 147.728 222.128 147.688 356.948-.118 278.195-226.522 504.543-504.693 504.543z"/>
                        <path fill={site?.id == 2470 ? "#928f88" : "#20b038"} d="M27.875 1190.114l82.211-300.18c-50.719-87.852-77.391-187.523-77.359-289.602.133-319.398 260.078-579.25 579.469-579.25 155.016.07 300.508 60.398 409.898 169.891 109.414 109.492 169.633 255.031 169.57 409.812-.133 319.406-260.094 579.281-579.445 579.281-.023 0 .016 0 0 0h-.258c-96.977-.031-192.266-24.375-276.898-70.5l-307.188 80.548z"/><image overflow="visible" opacity=".08" transform="translate(270.984 291.372)"/><path fillRule="evenodd" clipRule="evenodd" fill="#FFF" d="M462.273 349.294c-11.234-24.977-23.062-25.477-33.75-25.914-8.742-.375-18.75-.352-28.742-.352-10 0-26.25 3.758-39.992 18.766-13.75 15.008-52.5 51.289-52.5 125.078 0 73.797 53.75 145.102 61.242 155.117 7.5 10 103.758 166.266 256.203 226.383 126.695 49.961 152.477 40.023 179.977 37.523s88.734-36.273 101.234-71.297c12.5-35.016 12.5-65.031 8.75-71.305-3.75-6.25-13.75-10-28.75-17.5s-88.734-43.789-102.484-48.789-23.75-7.5-33.75 7.516c-10 15-38.727 48.773-47.477 58.773-8.75 10.023-17.5 11.273-32.5 3.773-15-7.523-63.305-23.344-120.609-74.438-44.586-39.75-74.688-88.844-83.438-103.859-8.75-15-.938-23.125 6.586-30.602 6.734-6.719 15-17.508 22.5-26.266 7.484-8.758 9.984-15.008 14.984-25.008 5-10.016 2.5-18.773-1.25-26.273s-32.898-81.67-46.234-111.326z"/>
                        <path fill="#FFF" d="M1036.898 176.091C923.562 62.677 772.859.185 612.297.114 281.43.114 12.172 269.286 12.039 600.137 12 705.896 39.633 809.13 92.156 900.13L7 1211.067l318.203-83.438c87.672 47.812 186.383 73.008 286.836 73.047h.255.003c330.812 0 600.109-269.219 600.25-600.055.055-160.343-62.328-311.108-175.649-424.53zm-424.601 923.242h-.195c-89.539-.047-177.344-24.086-253.93-69.531l-18.227-10.805-188.828 49.508 50.414-184.039-11.875-18.867c-49.945-79.414-76.312-171.188-76.273-265.422.109-274.992 223.906-498.711 499.102-498.711 133.266.055 258.516 52 352.719 146.266 94.195 94.266 146.031 219.578 145.992 352.852-.118 274.999-223.923 498.749-498.899 498.749z"/>
                    </svg>
                </button>
            )}
            {site && site?.id != 2049 && whatsAppActivated && (
                <WhatsAppComponent site={site} codsite={codsite2} origin={origin} open={open} setOpen={setOpen}/>
            )}
            {favorito?.length > 0 ? (
                <LazyRender>
                    <FavoritosComponent site={site} favorito={favorito} compartilhar={false} codsite={codsite2}/>
                </LazyRender>
            ) : null }
            {site?.modelo_topo == 3 ?
                <Topo2 site={site} setActiveDrawer={setActiveDrawer} setBuscaAvancada={setBuscaAvancada}/>
            :
                <Topo site={site} setActiveDrawer={setActiveDrawer}/>
            }
            {renderWelcomePieces()}

            {site?.modelo_selection == 2 && (
                <LazyRender>
                    <SelectionCarousel site={site} allCaract={listCaracteristicas} codsite={codsite}/>
                </LazyRender>
            )}

            {resolvedUrlBannerHome && resolvedUrlBannerHome.length > 0 && site?.id != 2052 && site?.id != 2523 && site?.id != 2291 && site?.id != 2226 ? (
                <LazyRender>
                    <MotionDiv
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <NoveltyPieces banner={resolvedUrlBannerHome} site={site}/>
                    </MotionDiv>
                </LazyRender>
            ) : null}

            {site?.modelo_cidades == 1 && allDataHome?.allBanners ? (
                <LazyRender>
                    <SelectionCarouselImages
                        banners={allDataHome?.allBanners || []}
                        codsite={codsite2}
                        filterTitle="carrossel_destaques"
                    />
                </LazyRender>
            ) : null}

            {((urlBannerPopup && urlBannerPopup.length > 0) || site?.id == 2238) && fullScreenPopup ? (
                <LazyRender>
                    <Popup banner={urlBannerPopup} setFullScram={setFullScreenPopup} site={site}/>
                </LazyRender>
            ) : null}

            {site?.id != 2551 ? renderFeaturedHomeCarousel() : null}

            {(allCarrosseis?.length > 0 || (total_carrosseis > 0 && !carregando_carrosseis)) ? (
                <LazyRender rootMargin="300px 0px">
                    {allCarrosseis?.length > 0 ?
                        allCarrosseis.map((carrossel: any, idx: Key | null | undefined) => renderCarrosselCard(carrossel, idx))
                    : total_carrosseis > 0 && !carregando_carrosseis &&
                        allDataHome?.carrosseis.map((e, id) => (
                            <MotionDiv
                                key={id}
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                                viewport={{ once: true, amount: 0.22 }}
                            >
                                <SkeletonApartamentCard carrossel={e}/>
                            </MotionDiv>
                        ))
                    }
                </LazyRender>
            ) : null}

            {(urlBannePersonaRedes && site?.exibe_redes_sociais && (allDataHome?.redes_sociais?.length) || site?.id == 2301) && (
                <LazyRender>
                    <MotionDiv
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <SocialNetworks site={site} props={init_props} urlBannerRedesSociais={urlBannerRedesSociais?.url} urlBannePersonaRedes={urlBannePersonaRedes?.url}></SocialNetworks>
                    </MotionDiv>
                </LazyRender>
            )}

            {allOwners?.paragrafo_3 == "2" && site?.banner_home == "1" ? (
                <LazyRender>
                    <MotionDiv
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <BusinessPieces
                            site={site}
                            allOwners={allOwners}
                        />
                    </MotionDiv>
                </LazyRender>
            ) : site?.banner_home == "1" && (allOwners?.paragrafo_1 || allOwners?.subtitulo_1 || allOwners?.linkbanner) && (!isMobile1 || site?.id == 2479) ? (
                <LazyRender>
                    <MotionDiv
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <OwnersPieces
                            allOwners={allOwners}
                            site={site}
                            setFullScram={setFullScreen}
                        />
                    </MotionDiv>
                </LazyRender>
                ) : null
            }

            {site?.modelo_equipe != 0 && site?.carrossel_corretores && allManagers.length && site?.id != 1968 ? (
                <LazyRender>
                <div id="equipe">
                    <MotionDiv
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <ManagerCard
                            slides={allManagers}
                            title={site?.id == 2433 ? "CORRETOR DE IMÓVEIS" : site?.id == 2098 || site?.id == 2146 ? "ATENDIMENTO EXCLUSIVO" : site?.id == 1959 || site?.id == 2091 ? "FALE CONOSCO" : site?.id == 2122 ? "COMPRA, VENDA E LOCAÇÃO DE IMÓVEIS" : site?.id == 2551 ? "EQUIPE DE VENDAS" : "NOSSA EQUIPE"}
                            site={site}
                        />
                    </MotionDiv>
                </div>
                </LazyRender>
            ) : null}
            {allDepoimentos.length && site?.modelo_depoimento != 0 ? (
                <LazyRender>
                    {site?.modelo_depoimento == 2 ? (
                        <MotionDiv
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                            viewport={{ once: true, amount: 0.22 }}
                        >
                            <DepoimentoCard2
                                slides={allDepoimentos}
                                title="DEPOIMENTOS"
                                site={site}
                            />
                        </MotionDiv>
                    ) : (
                        <MotionDiv
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                            viewport={{ once: true, amount: 0.22 }}
                        >
                            <DepoimentoCard
                                slides={allDepoimentos}
                                title="DEPOIMENTOS"
                                site={site}
                            />
                        </MotionDiv>
                    )}
                </LazyRender>
            ) : null}

            {site?.id == 2551 ? renderFeaturedHomeCarousel() : null}

            {resolvedUrlBannerHome && resolvedUrlBannerHome.length > 0 && site?.id == 2226 ? (
                <LazyRender>
                    <MotionDiv
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <NoveltyPieces banner={resolvedUrlBannerHome} site={site}/>
                    </MotionDiv>
                </LazyRender>
            ) : null}
            {(!isMobile1 || site?.id == 2091 || site?.id == 2422 || site?.id == 2226) && (site?.widget_instagram || dataHome?.videos) && politic === 'accepted' ? (
                <LazyRender>
                    <MotionDiv
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <NoticePieces site={site} title={site?.id == 1609 ? "FIQUE POR DENTRO": `NOSSO INSTAGRAM ${site?.id == 1559 ? " NH" : ""}`} videos={dataHome?.videos}/>
                    </MotionDiv>
                </LazyRender>
            ) : null}
            {resolvedUrlBannerHome && resolvedUrlBannerHome.length > 0 && site?.id == 2291 ? (
                <LazyRender>
                    <MotionDiv
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <NoveltyPieces banner={resolvedUrlBannerHome} site={site}/>
                    </MotionDiv>
                </LazyRender>
            ) : null}
            {(!isMobile1 || site?.id == 2091 || site?.id == 2422) && site?.modelo_fundo == 1 ? (
                <LazyRender>
                    <MotionDiv
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <Novidades isMobile={isMobile1} site={site} setFullScram={setFullScreen} bannerWelcome={urlBannerFundo}/>
                    </MotionDiv>
                </LazyRender>
            ) : null}
            {fullScreen && site?.simulador && site?.simulador != undefined ?
                <Simulador site={site} setFullScram={setFullScreen} flutua={1} origin={origin}/>
            : null}
            {resolvedUrlBannerHome && resolvedUrlBannerHome.length > 0 && (site?.id == 2052 || site?.id == 2523) ?  (
                <LazyRender>
                    <MotionDiv
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <NoveltyPieces banner={resolvedUrlBannerHome} site={site} disableHover backgroundColor={site?.id == 2523 ? "#000" : "#fff"}/>
                    </MotionDiv>
                </LazyRender>
            ) : null}
            {allDataHome?.blogs[0]?.id && site?.modelo_blogs == 2 ? (
                <LazyRender>
                    <BlogCarousel site={site} posts={allDataHome?.blogs} bannerUrl={urlBlogFundo} codsite={codsite2} origin={origin}/>
                </LazyRender>
            ) : null}
            <LazyRender>
                {renderRodape()}
            </LazyRender>
            {site ? (
                <LazyRender>
                    <PopUpComponent site={site}/>
                </LazyRender>
            ) : null}
        </div>
    );
};

export default Home;
